import React, {FC} from "react"
import {useIntl} from "@irati/utils/lang"
import Flex from "@irati/ui/src/Flex"
import {BenefitInfoContainer, BenefitImage} from "../../styled"
import {BenefitTextContent} from "./BenefitTextContent"

interface Props {
  title?: string
  imagePosition?: "left" | "right"
  body?: string
  ctaText?: string
  secondCtaText?: string
  videoUrl?: string
  ctaUrl?: string
  secondCtaUrl?: string
  imageSrc?: string
  logoSrc?: string
  tilesData?: Array<any>
}

export const BenefitCardInfo: FC<Props> = ({
  title,
  imagePosition,
  imageSrc,
  body,
  ctaText,
  logoSrc,
  tilesData,
  ctaUrl,
  videoUrl,
  secondCtaText,
  secondCtaUrl
}) => {
  const {formatMessage} = useIntl()

  return (
    <Flex justifyContent={"center"}>
      <BenefitInfoContainer>
        {imagePosition === "left" && (
          <>
            {imageSrc && (
              <Flex flex="1">
                <BenefitImage src={formatMessage({id: imageSrc})} alt="ALP-left-image" imagePosition={imagePosition} />
              </Flex>
            )}
            {videoUrl && (
              <Flex flex="2">
                <iframe
                  src={formatMessage({id: videoUrl})}
                  frameBorder="0"
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  title={title}
                  style={{
                    position: "relative",
                    height: "100%",
                    width: "100%"
                  }}
                />
              </Flex>
            )}
          </>
        )}
        <BenefitTextContent
          ctaUrl={ctaUrl}
          title={title}
          body={body}
          ctaText={ctaText}
          logoSrc={logoSrc}
          tilesData={tilesData}
          secondCtaText={secondCtaText}
          secondCtaUrl={secondCtaUrl}
        />
        {imagePosition === "right" && (
          <Flex flex="1">
            <BenefitImage src={formatMessage({id: imageSrc})} alt="ALP-left-image" imagePosition={imagePosition} />
          </Flex>
        )}
      </BenefitInfoContainer>
    </Flex>
  )
}
